module.exports = __webpack_public_path__ + "images/3bbd63439e1f002bc6414f4e67e1cd1e-logo_wide.png";